import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from 'react-query'
import { registerSW } from 'virtual:pwa-register'
import App from './App'
import './styles/index.css'

// Initialize Firebase early
import './services/firebase'

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      cacheTime: 1000 * 60 * 10, // 10 minutes
      retry: 3,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      refetchOnWindowFocus: false,
    },
  },
})

// Register service worker only in production to avoid dev caching issues
let updateSW: any = null
if (import.meta.env.PROD) {
  updateSW = registerSW({
    onNeedRefresh() {
      const shouldUpdate = window.confirm('New content available! Click OK to refresh.')
      if (shouldUpdate) {
        updateSW(true)
      }
    },
    onOfflineReady() {
    },
  })
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
)
